<template>
  <div class="flex justify-between items-center gap-2 font-rubik">
    <div 
      class="status-circle" 
      :class="{ 'status-circle-active': !isActive }"
    ></div>

    <div class="flex items-center font-rubik">
      <button
        @click="toggle"
        class="toggle-container relative inline-flex items-center h-7 w-14 rounded-full focus:outline-none"
      >
        <div
          class="w-full"
          :class="{ 'text-left pl-1': isActive, 'text-right pr-1': !isActive }"
        >
          <p class="button-text">{{ isActive ? 'BUY' : 'RENT' }}</p>
        </div>
        <span
          class="absolute toggle-arrow w-6 h-6 bg-white rounded-full shadow"
          :class="{ 'toggle-active': isActive, 'toggle-inactive': !isActive }"
        ></span>
      </button>
    </div>

    <div 
      class="status-circle" 
      :class="{ 'status-circle-active': isActive }"
    ></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: true
    }
  },
  mounted() {
    this.$emit('toggleValue', 'sale')
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive
      this.$emit('toggleValue', this.isActive ? 'sale' : 'rental')
    }
  }
}
</script>

<style scoped>
.toggle-container {
  background-color: #334155;
}

.button-text {
  font-size: 10px;
  font-weight: 600;
  line-height: 8px;
  letter-spacing: -0.04em;
  color: white;
}

.toggle-inactive {
  transform: translateX(0px);
  left: 2px;
}

.toggle-active {
  transform: translateX(28px);
  left: 2px;
}

.toggle-arrow {
  transition: transform 0.3s ease-in-out;
}

.status-circle {
  width: 7px;
  height: 7px;
  border: 1px solid #EDE9E3;
  border-radius: 9999px;
  background-color: #FFFFFF;
  transition: background-color 0.3s ease, opacity 0.3s ease;
}

.status-circle-active {
  background-color: #172FDE;
  border: 1px solid #172FDE;
}
</style>